import Ahoy from './ahoy'
// import Criteo from './criteo' // toggle if somebody will cry
import GTag from './gtag'
import MetaPixel from './meta-pixel'
import Bugsnag from './bugsnag'
// import Clarity from './clarity' // toggle if somebody will cry
import Intercom from './intercom'
import { productionEnv } from 'lib/env'

// the event type is unified for all conversions, and looks like this:
// { event, [type], [...otherData] }
class ConversionSet {
  constructor (conversionSet) {
    this._conversionSet = conversionSet
  }

  register (conversion) {
    this._conversionSet.push(conversion)
  }

  get registry () {
    return [...this._conversionSet]
  }

  // only meta pixel implemented for now
  addAccountIDs (config) {
    if (!config?.metaPixelIds) return
    const metaPixel = this.registry.find(item => item instanceof MetaPixel)
    if (!metaPixel) return
    for (const id of config.metaPixelIds) {
      metaPixel.addID(id)
    }
  }

  async push (...args) {
    return this._conversionSet.forEach((conversion) => {
      try {
        return conversion.push(...args)
      } catch (e) {
        console.error('push', e)
      }
    })
  }

  static get instance () {
    if (this._instance) return this._instance
    this._instance = new this(this.default_conversions)

    return this._instance
  }

  static get default_conversions () {
    if (productionEnv) {
      // body[data-no-analytics] (a valueless attribute, hence `in`) keeps a page out of the trackers
      return ('noAnalytics' in document.body.dataset ? [Bugsnag, Intercom] : [Bugsnag, Ahoy, GTag, Intercom, MetaPixel])
        .map(it => it.instance())
    } else {
      return [Ahoy].map(it => it.instance())
    }
  }
}

export default ConversionSet.instance
